module.exports = __webpack_public_path__ + "media/images/bg_pattern-chart-a0462d1d1c268e96a8e606c08c456192.jpg";